import {
  InputLabel,
  TextField as MuiTextField,
  TextFieldProps as MuiTextFieldProps,
  Typography,
} from '@mui/material';

type TextFieldBaseProps = Omit<MuiTextFieldProps, 'inputRef'>;

export interface TextFieldProps extends TextFieldBaseProps {
  outerLabel?: boolean;
}

export function TextField({
  variant,
  outerLabel = false,
  label,
  id,
  error,
  required,
  helperText,
  disabled,
  ...rest
}: TextFieldProps) {
  return (
    <>
      {outerLabel && label && (
        <InputLabel shrink={false} htmlFor={id}>
          <Typography variant="body1" color={error ? 'error' : 'initial'}>
            {label} {required && <span>*</span>}
          </Typography>
        </InputLabel>
      )}
      <MuiTextField
        sx={{ backgroundColor: disabled ? 'grey.200' : 'white' }}
        required={required}
        error={error}
        disabled={disabled}
        variant={variant}
        id={id}
        {...rest}
        {...(!outerLabel && { label })}
      />
      {helperText && (
        <Typography variant="body1" color={error ? 'error' : 'initial'}>
          {helperText}
        </Typography>
      )}
    </>
  );
}

export default TextField;
